import React, { memo } from 'react'
import { Handle } from 'react-flow-renderer'
import Typography from '@material-ui/core/Typography'
import { Grid } from '@material-ui/core'
import InstructionWizardMockup from '../../../../assets/images/InstructionWizardMockup.png'

export default memo(({ data }) => {
    const textOption = data.testOptions?.find(to => to.scenarioInteractiveElementType === 4)
    const imageOption = data.testOptions?.find(to => to.scenarioInteractiveElementType === 7)
    const taskText = textOption?.text || ''
    const imageUrl = imageOption?.imageUrl || null

    return (
        <>
            <div>
                <img
                    src={InstructionWizardMockup}
                    style={{
                        position: 'relative',
                        width: '100px',
                        height: 'auto',
                    }}
                />
                <Grid style={{ position: 'absolute', top: 70, left: 0 }} container>
                    {taskText && (
                        <Grid item xs={12} sm={12}>
                            <Typography
                                variant="body2"
                                style={{
                                    marginTop: '12px',
                                    marginLeft: '3px',
                                    width: '70px',
                                    boxShadow: 'none',
                                    flex: 1,
                                    fontSize: '5px',
                                    fontWeight: 'bold',
                                    color: '#6B4C9A',
                                    justifyContent: 'left',
                                    paddingLeft: '10px',
                                    paddingRight: '10px',
                                    alignItems: 'center',
                                }}>
                                {taskText}
                            </Typography>
                        </Grid>
                    )}
                    <Grid item xs={12} sm={12}>
                        <Typography
                            variant="body2"
                            style={{
                                marginTop: '10px',
                                marginLeft: '3px',
                                width: '70px',
                                boxShadow: 'none',
                                flex: 1,
                                fontSize: '4px',
                                fontWeight: 'bold',
                                color: '#8E8E93',
                                fontStyle: 'italic',
                                justifyContent: 'left',
                                paddingLeft: '10px',
                                paddingRight: '10px',
                                alignItems: 'center',
                            }}>
                            [Writing input]
                        </Typography>
                    </Grid>
                </Grid>
            </div>
            <Handle type="target" position="left" id="target1" style={{ top: '98.5px', background: '#555' }} />
            <Handle type="source" position="right" id="exit0" style={{ top: '98.5px', background: '#555' }} />
        </>
    )
})
